import React from "react";
import Icon from "@material-ui/core/Icon";

const element = (props) => {
  return (
    <Icon
      className={props.classIcon}
      style={{ color: props.color, fontSize: props.size , margin:props.margin}}
      onClick={props.action}
      aria-label={props.label}>
      {props.children}
    </Icon>
  );
};

export default element;
